import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import { AgCharts } from 'ag-charts-community';
import ChartExportMenu from './ChartExportMenu';

/**
 * Imperative AG Charts wrapper — safer with CRA webpack 3 than the ESM React package.
 * Optional Apex-style export menu (SVG / PNG / CSV) in the chart top-right.
 */
class AgChart extends React.Component {
  chart = null;

  componentDidMount() {
    this.createOrUpdate();
  }

  componentDidUpdate() {
    this.createOrUpdate();
  }

  componentWillUnmount() {
    if (this.chart) {
      this.chart.destroy();
      this.chart = null;
    }
  }

  getChart = () => this.chart;

  createOrUpdate = () => {
    if (!this.el) return;
    const options = {
      ...(this.props.options || {}),
      container: this.el,
    };
    try {
      if (this.chart) {
        AgCharts.update(this.chart, options);
      } else {
        this.chart = AgCharts.create(options);
      }
    } catch (err) {
      console.error('[AgChart]', err);
    }
  };

  render() {
    const {
      height = 320,
      style,
      showExport = true,
      fileName = 'chart',
      options,
    } = this.props;

    return (
      <Box sx={{ position: 'relative', width: '100%', ...(style || {}) }}>
        {showExport ? (
          <Box
            sx={{
              position: 'absolute',
              top: 4,
              right: 4,
              zIndex: 3,
            }}
          >
            <ChartExportMenu
              chartRef={this}
              fileName={fileName}
              options={options}
            />
          </Box>
        ) : null}
        <div
          ref={(el) => {
            this.el = el;
          }}
          style={{ width: '100%', height }}
        />
      </Box>
    );
  }
}

AgChart.propTypes = {
  options: PropTypes.object,
  height: PropTypes.number,
  style: PropTypes.object,
  showExport: PropTypes.bool,
  fileName: PropTypes.string,
};

export default AgChart;



// WEBPACK FOOTER //
// ./src/components/dashboard2/AgChart.js